<template>
  <v-dialog
      v-model="dialog"
      width="600"
      large
  >
    <template v-slot:activator="{ on, attrs }">
      <v-icon
          v-if="item == null"
          v-bind="attrs"
          v-on="on"
      >
        mdi-plus-box
      </v-icon>
      <v-icon
          v-else
          small
          v-bind="attrs"
          v-on="on"
      >
        mdi-pencil-circle
      </v-icon>
    </template>
    <v-card>
      <v-card-title v-if="localItem.user.id === null">
        New contract
      </v-card-title>
      <v-card-title v-else>
        Contract for  {{ localItem.user.user }} ({{ localItem.user.employee_number }})
      </v-card-title>
      <v-card-text>
        <v-form
            ref="ContractNewForm"
            v-model="form"
        >
          <v-row>
            <v-col cols="9">
              <v-text-field
                  :rules="[rules.required]"
                  label="Name"
                  type="text"
                  v-model="localItem.name"
                  :value="localItem.name"
              >
              </v-text-field>
            </v-col>
            <v-col cols="3">
              <v-checkbox
                  label="Active"
                  v-model="localItem.active"
                  :value="localItem.active"
              >
              </v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" v-if="item === null">
              <v-autocomplete
                  :rules="[rules.required]"
                  v-model="localItem.user.id"
                  :items="userList"
                  label="User"
                  clearable
                  hint="Enter users name or employee number"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                  :rules="[rules.required]"
                  label="From"
                  type="date"
                  v-model="localItem.from_date"
                  :value="localItem.from_date"
              >
              </v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                  label="To"
                  type="date"
                  v-model="localItem.to_date"
                  :value="localItem.to_date"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-text-field
                  label="Holiday offset"
                  type="number"
                  v-model="localItem.holiday_offset"
                  :value="localItem.holiday_offset"
              >
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                  label="Time offset"
                  type="number"
                  v-model="localItem.time_offset"
                  :value="localItem.time_offset"
              >
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                  label="Holidays per year"
                  type="number"
                  v-model="localItem.holiday_per_year"
                  :value="localItem.holiday_per_year"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                <tr>
                  <td
                      v-for="index in [...Array(7).keys()]"
                      :key="index"
                      class="text-center"
                  >
                    <v-text-field
                        type="number"
                        class="no-spin mx-0 my-7 px-0"
                        v-model.number="localItem.working_hours[index]"
                        outlined
                        :label="getWeekDay[index]"
                    >
                    </v-text-field>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-row>
          <v-row>
            <v-textarea
                label="Comment"
                v-model="localItem.comment"
                outlined
            >

            </v-textarea>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
            @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
            v-if="item == null"
            :disabled="!form"
            @click="onSave"
        >
          Add
        </v-btn>
        <v-btn
            v-else
            :disabled="!form"
            @click="onSave"
        >
          Save
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {mapFields} from "vuex-map-fields";

export default {
  name: 'ContractNewEditDialog',
  props: {
    item: {default: null},
    length: {default: null},
    disabled: {default: false}
  },

  computed: {
    ...mapGetters('Contract', ['getColumns',]),
    ...mapFields('Contract', ['message_error', 'options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'isAlive', 'action_loading', 'filters', 'local_phrase', 'lang',]),
    ...mapFields('HumanUser', {itemListHuman: 'itemList'},),

    getWeekDay() {
      return ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
    },

    userList() {
      let user_list = []
      this.itemListHuman.forEach(row => user_list.push({
        text: row.user + '(' + row.employee_number + ')',
        value: row.id
      }))
      return user_list
    },
  },

  methods: {
    ...mapActions('Contract', ['fetchSaveItemField']),


    onSave() {
      console.log('onSave', this.localItem)
      let fields_dict = {}
      fields_dict['name'] = this.localItem.name
      fields_dict['user'] = {id: this.localItem.user.id}
      fields_dict['from_date'] = this.localItem.from_date
      fields_dict['to_date'] = this.localItem.to_date
      fields_dict['active'] = !!this.localItem.active
      fields_dict['working_hours'] = this.localItem.working_hours
      fields_dict['comment'] = this.localItem.comment
      fields_dict['holiday_offset'] = this.localItem.holiday_offset
      fields_dict['time_offset'] = this.localItem.time_offset
      fields_dict['holiday_per_year'] = this.localItem.holiday_per_year

      this.fetchSaveItemField({
        itemId: this.localItem.id,
        fields_dict: fields_dict,
        dto_model: {to_consumer: 'ContractDTO', from_consumer: 'ContractDTO'}
      })
      this.dialog = false
      if (this.item === null) {
        this.$refs['ContractNewForm'].resetValidation()
        this.localItem = {
          id: null,
          name: null,
          user: {id: null},
          from_date: null,
          to_date: null,
          active: true,
          working_hours: [0, 0, 0, 0, 0, 0, 0],
          holiday_offset: 0,
          time_offset: 0,
          holiday_per_year: 0,
          comment: null,
        }
      }
    },
  },

  mounted() {
    // console.log('mounted', this.item)
    if (this.item != null)
      this.localItem = this.item
  },

  data() {
    return {
      dialog: false,
      itemSaved: null,
      form: false,
      localItem: {
        id: null,
        name: null,
        user: {id: null},
        from_date: null,
        to_date: null,
        active: true,
        working_hours: [0, 0, 0, 0, 0, 0, 0],
        holiday_offset: 0,
        time_offset: 0,
        comment: null,
      },
      rules: {
        min: len => v => (v || '').length >= len || `Invalid character length, required great or equal ${len}`,
        max: len => v => (v || '').length <= len || `Invalid character length, required low or equal ${len}`,
        required: v => !!v || 'This field is required',
      },
    }
  }
}

</script>


<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
}

.no-spin input::-webkit-outer-spin-button,
.no-spin input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

</style>